<template>
<div>
  <div class="container">
    <h1>隐私声明</h1>
    <p>本《用户注册协议》由您（以下简称“用户”、“您”）与普莱柯生物工程股份有限公司（以下简称 “普莱柯”“我们”）就您使用 “莱柯云”应用程序/平台服务所达成的有效协议(以下简称"本协议")。</p>
    <p>请您在使用普莱柯服务前务必事先认真阅读本协议中的各条款，特别是其中所涉及您和我们权利义务的条款，并在阅读后选择"接受"或"拒绝"本协议。同时，您应当主动了解平台不定期发布的公告、通知等文件内容。除非您接受本协议所有条款，否则您将无法使用普莱柯服务。您一经注册并点击确认或同意或使用中科基因服务即视为对本协议全部条款已充分理解并完全接受。</p>
    <strong>一、声明与承诺</strong>
    <p>1.您确认，在您注册成为普莱柯用户接受本服务前，已充分阅读、理解并接受本协议的全部内容，一旦您签署本协议，即意味着您须按照本协议约定使用普莱柯服务，若您给普莱柯或其他用户造成损失的，您应当承担相应责任。</p>
    <p>2.您同意并知晓，我们有权对本协议内容进行修改或变更，并将以公告、邮件、短信推送及普莱柯平台弹窗或其他方式予以公布，您可以通过普莱柯应用程序/平台等途径查阅；若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容，您应停止使用本服务或注销普莱柯账号。</p>
    <strong>二、普莱柯莱柯云账户 注册：</strong>
    <p>您在申请注册普莱柯账户时，我们需要收集和使用您的相关信息。您应当准确提供并及时更新您提供的联系电话信息，以便我们与您进行及时、有效联系。如您提供的注册资料不合法、不真实、不准确的，您需承担因此引起的相应责任和后果。</p>
    <strong>使用：</strong>
    <p>您应当确保申请普莱柯的账户仅能为您本人使用，并妥善保管账户密码，若您擅自转让、出租给第三方使用导致中科基因或您的权益受损，由您承担该责任。当您账户被盗用时，应当及时联系中科基因申请暂停服务，避免扩大您的损失。</p>
    <strong>三、 您信息的使用授权和保护</strong>
    <p>1. 普莱柯尊重并保护您的个人信息，我们将严格按照本协议及具体服务中与您关于信息授权的约定，收集、使用、存储、披露您的您个人信息。</p>
    <p>1）您以任何方式使用中科基因司的相关服务，即表示您已充分阅读、理解并同意接受相应的服务协议；</p>
    <p>3.您应当认真阅读本协议条款，如您不同意本协议关于您信息使用或具体服务中的任一项关于您的个人信息授权的约定，您可能无法使用中科基因服务，当您点击“确认”或“同意”本协议视为您同意本协议约定内容并授权我们按如下约定收集、保存、分析、使用、向第三方提供您的相关个人信息：</p>
    <p>1）用户注册</p>
    <p>当您注册时，您需要向我们提供您本人的手机号码、注册验证码信息。</p>
    <p>2) 请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除您删除或通过系统设置拒绝我们收集之外，我们将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用，删除您的个人信息或对您个人信息进行匿名化处理。</p>
    <p>3) 我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</p>
    <p>4) 存在以下情形中，我们收集、使用您的个人信息无需征得您的授权同意：</p>
    <p>a.与国家安全、国防安全有关的；b.与公共安全、公共卫生、重大公共利益有关的；c.与犯罪侦查、起诉、审判和判决执行等有关的；d.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；e.所收集的个人信息是个人信息主体自行向社会公众公开的；f.从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；g.根据您的要求签订合同所必需的；h.用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；i.为合法的新闻报道所必需的；j.学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；k.法律法规规定的其他情形。</p>
    <strong>四、 隐私政策</strong>
    <p>本隐私政策与您所使用的莱柯云app服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本隐私政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。</p>
    <p>1. 我们如何收集和使用您的个人信息</p>
    <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括：基本信息（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）；个人身份信息（包括身份证、军官证、护照、驾驶证等）；面部特征；网络身份标识信息（包括系统账号、IP地址、邮箱地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（交易和消费记录、以及余额、优惠券等虚拟财产信息）；通讯录；个人上网记录（包括网站浏览记录、软件使用记录、点击记录）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息））；个人位置信息（包括行程信息、精准定位信息、住宿信息、经纬度等）；</p>
    <p>个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私政策中涉及的个人敏感信息包括：您的财产信息（包括交易记录及莱柯云余额、优惠券等虚拟财产信息）；面部识别特征；个人身份信息（包括身份证、军官证、护照、驾驶证、户口本）；网络身份识别信息（包括账号、邮箱地址及与前述有关的密码口令的组合）；其他信息（包括通讯录、行程信息、网页浏览记录、精准定位信息）。</p>
    <p>2. 保障交易安全所必须的功能</p>
    <p>为提高您使用我们的产品与/或服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，我们可能会通过了解您的浏览信息、订单信息、您常用的软件信息、设备信息等手段来判断您的账号风险，并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息对于莱柯云系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。</p>
    <p>3. 您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</p>
    <p>1）与国家安全、国防安全有关的；</p>
    <p>2）与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
    <p>5）所收集的个人信息是个人信息主体或监护人自行向社会公众公开的；</p>
    <p>6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
    <p>7）根据您的要求签订合同所必需的；</p>
    <p>8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</p>
    <p>9）为合法的新闻报道所必需的；</p>
    <p>10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
    <p>11）法律法规规定的其他情形。</p>
    <p>4. 您个人信息使用的规则</p>
    <p>1）我们会根据本隐私政策的约定并为实现我们的产品与/或服务功能对所收集的个人信息进行使用。</p>
    <p>2）在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</p>
    <p>3）请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息，具体请详见本隐私政策附件《莱柯云账户注销须知》。</p>
    <p>4）我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</p>
    <p>5）当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。</p>
    <p>6）当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意。</p>
    <strong>五、 知识产权</strong>
    <p>1. 普莱柯有用应用程序/平台及服务的著作权、商标权、商业秘密以及其他相关的知识产权，包括但不限于各种文档资料、软件、商标、FLASH、设计、图案、音像、摄影、动画、美术等，及其它本协议中未经提及的知识产权均由中科基因享有。</p>
    <p>2.未经我们事先书面同意，您不得为任何营利性或非营利性的目的自行实施、利用、转让或许可任何第三方实施、利用、转让上述知识产权。</p>
    <strong>六、 免责条款</strong>
    <p>普莱柯应用程序/平台因线路维修、故障、黑客攻击、电信部门技术调整或故障、网站升级、银行方行为或原因、意外事件、不可抗力等状况无法正常运作，使您无法使用各项服务时，我们不承担损害赔偿责任。</p>
    <strong>七、 违约责任</strong>
    <p>1.您在使用普莱柯服务时，应严格遵守本协议的约定。若您有任何违反本协议或相关法规的规定，我们有权视您的行为性质，在不事先通知您的情况下，采取包括但不限于中断使用许可、限制使用、中止或终止服务、追究法律责任等措施，若因此造成中科基因或他人损失的，您应予赔偿。</p>
    <p>2.您不得利用普莱柯产品进行任何违反国家现行法律及各法规、损害社会集体、损害普莱柯、普莱柯合作方或任何其他第三方的利益的行为，否则我们有权立即终止为您提供服务，并要求您赔偿损失，由此产生的后果由您自行承担。</p>
    <p>3.我们有权判定您的行为是否符合本协议的要求，出现包括但不限于以下情形的，我们有权单方在不作通知的情况下终止对您提供的服务，由此产生的风险及责任由您自行承担。如造成我们损失的，您还应承担赔偿等责任：</p>
    <p>1) 您提供的资料不真实；</p>
    <p>2) 您违反本协议中规定的使用规则；</p>
    <p>3) 您未按时足额支付使用普莱柯服务的费用（如有）；</p>
    <p>4) 您违反本协议其它规定，且自普莱柯公司通知其纠正之日起10个工作日内仍未纠正的。</p>
    <strong>八、 执行和变更</strong>
    <p>我们有权根据需要修改、增加或删减本协议并将以公告、邮件、短信推送及普莱柯平台弹窗或其他方式通知您相关修改、增加或删减的内容。一经前述方式进行公告的，即视为上述内容已经通知到您。若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容，您应停止使用本服务或注销普莱柯莱柯云账号。</p>
    <strong>九、 适用法律</strong>
    <p>本协议适用于中华人民共和国大陆地区法律、法规。若您和我们之间发生任何纠纷或争议，应友好协商解决，协商不成的，您可将纠纷或争议提交普莱柯所在地河南省洛阳区人民法院诉讼解决。</p>
    <strong>十、 联系我们</strong>
    <p>如果您对本协议有任何问题，请通过以下途径联系普莱柯</p>
    <p>办公地址： 中国（河南）自由贸易试验区洛阳片区高新开发区凌波路</p>
    <p>普莱柯生物工程股份有限公司会尽最大努力在合理时间内回复您</p>

    <p  class="right">生效日期： 2020  年 02 月 13 日</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'agreement-privacy',
}
</script>

<style scoped>
  @import '../assets/style/style.css';
</style>